module.exports = {
  // 页面是否透明
  isAppTransparent: true,
  // 导航助手是否显示（由 web/position/showNavAssistant 接口决定，true=显示，false=不显示，null=未获取）
  navAssistantEnabled: null,
}



// WEBPACK FOOTER //
// ./src/store/app/state.js